import { render, staticRenderFns } from "./StoreDownloadLink.vue?vue&type=template&id=4c4ace06&scoped=true"
import script from "./StoreDownloadLink.vue?vue&type=script&lang=js"
export * from "./StoreDownloadLink.vue?vue&type=script&lang=js"
import style0 from "./StoreDownloadLink.vue?vue&type=style&index=0&id=4c4ace06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ace06",
  null
  
)

export default component.exports